/*
  LAUNCH GIFT (added 2026-10-20, v7 = v4 behaviour for adds/increases)
  Auto-adds a free Organizer Bag 2L for every Commit 40L in the cart,
  and removes it if the 40L is removed. The $0 price comes from the
  automatic Buy X Get Y discount in Shopify admin, not from this file.
  - Adding the 40L or INCREASING its qty: organizer is adjusted just
    BEFORE that request (as in v4), so slide-out carts show both.
  - DECREASING / removing: not intercepted (pre-adjusting confused the
    Monster cart app). A sync right after fixes the organizer count and
    merges any organizer lines Shopify split into $0 + full price.
  Debug: open the browser console and look for [launch-gift] lines.
  To turn off: delete the launch-gift line at the bottom of
  snippets/meta-tags.liquid (and end the discount).
*/
(function () {
  var PACK_ID = 54149738561830; // Commit 40L Roll-Top Pack variant
  var GIFT_ID = 54150216679718; // Organizer Bag 2L variant
  var TAG = 'lg=1';             // marks our own requests so we don't loop
  var origFetch = window.fetch ? window.fetch.bind(window) : null;
  var busy = false;
  var again = false;
  var timer = null;
  function noop() {}
  function log() { try { console.log.apply(console, ['[launch-gift]'].concat([].slice.call(arguments))); } catch (e) {} }

  function onCartPage() { return /\/cart\/?$/.test(window.location.pathname); }
  function drawer() { return document.querySelector('cart-drawer'); }
  function sectionIds() {
    var d = drawer();
    return d && d.getSectionsToRender ? d.getSectionsToRender().map(function (s) { return s.id; }) : [];
  }

  function postJSON(url, payload, withSections) {
    if (withSections) {
      var ids = sectionIds();
      if (ids.length) { payload.sections = ids; payload.sections_url = window.location.pathname; }
    }
    return origFetch(url + '?' + TAG, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }
  function getCart() {
    return origFetch('/cart.js?' + TAG, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function giftLinesOf(cart) {
    return cart.items.filter(function (it) {
      return it.variant_id === GIFT_ID && it.properties && it.properties._launch_gift;
    });
  }
  function sumQty(lines) { return lines.reduce(function (n, it) { return n + it.quantity; }, 0); }
  function packQtyOf(cart) {
    return cart.items.reduce(function (n, it) { return n + (it.variant_id === PACK_ID ? it.quantity : 0); }, 0);
  }

  function setGift(giftLines, target, withSections) {
    if (!giftLines.length) {
      if (target <= 0) return Promise.resolve(null);
      log('add organizer x' + target);
      return postJSON('/cart/add.js', { items: [{ id: GIFT_ID, quantity: target, properties: { _launch_gift: 'true' } }] }, withSections);
    }
    if (giftLines.length === 1) {
      log('set organizer qty to ' + target);
      return postJSON('/cart/change.js', { id: giftLines[0].key, quantity: target }, withSections);
    }
    log('merge ' + giftLines.length + ' organizer lines into qty ' + target);
    var updates = {};
    giftLines.forEach(function (it, i) { updates[it.key] = i === 0 ? target : 0; });
    return postJSON('/cart/update.js', { updates: updates }, withSections);
  }

  function refresh(state) {
    if (!state || state.status) {
      if (state && state.status) console.warn('[launch-gift] cart error', state);
      return;
    }
    if (onCartPage()) { window.location.reload(); return; }
    var d = drawer();
    if (d && state.sections && d.renderContents) {
      if (typeof state.item_count === 'number') d.classList.toggle('is-empty', state.item_count === 0);
      else d.classList.remove('is-empty');
      d.renderContents(state);
    }
  }

  function sync() {
    if (!origFetch) return;
    if (busy) { again = true; return; }
    busy = true;
    getCart()
      .then(function (cart) {
        var packQty = packQtyOf(cart);
        var gl = giftLinesOf(cart);
        log('sync: packs=' + packQty + ' organizers=' + sumQty(gl) + ' organizerLines=' + gl.length);
        if (packQty === sumQty(gl) && gl.length <= 1) return null;
        return setGift(gl, packQty, true);
      })
      .then(refresh)
      .catch(function (e) { console.warn('[launch-gift]', e); })
      .finally(function () {
        busy = false;
        if (again) { again = false; sync(); }
      });
  }
  function scheduleSync() { clearTimeout(timer); timer = setTimeout(sync, 400); }

  function isOurs(url) { return String(url || '').indexOf(TAG) !== -1; }
  function isCartWrite(url) { return !isOurs(url) && /\/cart\/(add|change|update|clear)(\.js)?/.test(String(url || '')); }
  function isCartAdd(url) { return !isOurs(url) && /\/cart\/add(\.js)?/.test(String(url || '')); }
  function isCartQty(url) { return !isOurs(url) && /\/cart\/(change|update)(\.js)?/.test(String(url || '')); }

  function parseBody(body) {
    try {
      if (!body) return null;
      var o = {};
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        body.forEach(function (v, k) { if (typeof v === 'string') o[k] = v; });
        return { form: o };
      }
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) body = body.toString();
      if (typeof body !== 'string') return null;
      var t = body.trim();
      if (t.charAt(0) === '{') return { json: JSON.parse(t) };
      new URLSearchParams(t).forEach(function (v, k) { o[k] = v; });
      return { form: o };
    } catch (e) { return null; }
  }

  function packQtyInAdd(p) {
    if (!p) return 0;
    if (p.json) {
      var items = p.json.items || [{ id: p.json.id, quantity: p.json.quantity }];
      return items.reduce(function (n, it) { return n + (Number(it.id) === PACK_ID ? Number(it.quantity || 1) : 0); }, 0);
    }
    var f = p.form, n = 0;
    if (Number(f.id) === PACK_ID) return Number(f.quantity || 1);
    Object.keys(f).forEach(function (k) {
      var m = k.match(/^items\[(\d+)\]\[id\]$/);
      if (m && Number(f[k]) === PACK_ID) n += Number(f['items[' + m[1] + '][quantity]'] || 1);
    });
    return n;
  }

  function packQtyAfterChange(url, p, cart) {
    var lines = cart.items, target = {}, byLine = false;
    function idxOf(id) {
      id = String(id);
      for (var i = 0; i < lines.length; i++) {
        if (lines[i].key === id || String(lines[i].variant_id) === id) return i;
      }
      return -1;
    }
    var d = p.json || p.form;
    if (/\/cart\/change/.test(url)) {
      var q = Number(d.quantity);
      if (isNaN(q)) return null;
      var i = -1;
      if (d.line) { i = Number(d.line) - 1; byLine = true; }
      else if (d.id) i = idxOf(d.id);
      if (i < 0 || i >= lines.length) return null;
      target[i] = q;
    } else {
      var u = p.json ? p.json.updates : null;
      if (p.form) {
        var obj = {}, arr = [];
        Object.keys(p.form).forEach(function (k) {
          var m = k.match(/^updates\[(.*)\]$/);
          if (!m) return;
          if (m[1] === '') arr.push(p.form[k]); else obj[m[1]] = p.form[k];
        });
        u = arr.length ? arr : (Object.keys(obj).length ? obj : null);
      }
      if (!u) return null;
      if (Array.isArray(u)) { byLine = true; u.forEach(function (v, j) { target[j] = Number(v); }); }
      else Object.keys(u).forEach(function (k) { var j = idxOf(k); if (j >= 0) target[j] = Number(u[k]); });
    }
    var touches = false, total = 0;
    lines.forEach(function (it, j) {
      if (it.variant_id !== PACK_ID) return;
      if (j in target) { touches = true; total += target[j]; } else total += it.quantity;
    });
    return touches ? { total: total, byLine: byLine } : null;
  }

  function preflight(url, body) {
    if (!origFetch) return null;
    if (isCartAdd(url)) {
      var q = packQtyInAdd(parseBody(body));
      if (q <= 0) return null;
      log('pre-add organizer x' + q);
      return postJSON('/cart/add.js', { items: [{ id: GIFT_ID, quantity: q, properties: { _launch_gift: 'true' } }] }, false).catch(noop);
    }
    if (isCartQty(url)) {
      var p = parseBody(body);
      if (!p) return null;
      return getCart().then(function (cart) {
        var r = packQtyAfterChange(url, p, cart);
        if (!r) return;
        var gl = giftLinesOf(cart);
        var gq = sumQty(gl);
        if (r.total <= gq) return; // decrease/remove: leave to sync afterwards
        if (gl.length === 1) { log('pre-increase organizer to ' + r.total); return setGift(gl, r.total, false); }
        if (!gl.length && !r.byLine) return setGift(gl, r.total, false);
      }).catch(noop);
    }
    return null;
  }

  if (origFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var self = this, args = arguments;
      var pre = isCartWrite(url) ? preflight(url, init && init.body) : null;
      function go() {
        var pr = origFetch.apply(self, args);
        if (isCartWrite(url)) pr.then(scheduleSync, scheduleSync);
        return pr;
      }
      return pre ? pre.then(go, go) : go();
    };
  }

  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._lgUrl = url;
    if (isCartWrite(url)) this.addEventListener('loadend', scheduleSync);
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    var xhr = this, args = arguments;
    var pre = isCartWrite(xhr._lgUrl) ? preflight(String(xhr._lgUrl), body) : null;
    if (pre) { pre.then(function () { origSend.apply(xhr, args); }); return; }
    return origSend.apply(this, arguments);
  };

  function init() {
    sync();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleSync);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
